import { h } from '@stencil/core/internal/client';
import { a as toValue, t as toLabel } from './index5.js';
import { i as isLavOption } from './types.js';

function HiddenHTMLSelect({ disabled, required, name, options, value, ref, multiple, }) {
    return (h("select", { ref: ref, multiple: multiple, hidden: true, disabled: disabled, required: required, name: name }, options?.map((option) => {
        if (!isLavOption(option)) {
            return null;
        }
        const optionValue = toValue(option);
        const optionLabel = toLabel(option);
        const isOptionChecked = (value || []).includes(`${optionValue}`);
        const isOptionDisabled = typeof option === 'object' && option.disabled;
        return (h("option", { key: optionLabel, selected: isOptionChecked, disabled: disabled || isOptionDisabled, value: optionValue }, optionLabel));
    })));
}

export { HiddenHTMLSelect as H };

//# sourceMappingURL=hidden-html-select.js.map